module.exports = __webpack_public_path__ + "static/media/exporttype.4c5fdb09.svg";